export default __webpack_public_path__ + "static/heather-babd4f012442504476448e9b04e8d177.png";